export const logo = [
  '662 200',
  `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 662 200" style="enable-background:new 0 0 662 200;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#CFA65F;}
	.st1{fill:#A8CF6A;}
</style>
<path class="st0" d="M218.6,86.4l-10.7-18.6c-2.2-3.8-7-5.1-10.8-2.9c-3.8,2.2-5.1,7-2.9,10.8l14,24.2l-3.3,5.7c0,0,0,0,0,0
	l-21,36.4l-24.3,42.1H153H68.9h-6.5l-24.3-42.1l-21-36.4c0,0,0,0,0,0l-3.3-5.7l48.6-84.1h6.5H153h6.5l8.8,15.3l1.9,3.3
	c2.2,3.8,7,5.1,10.8,2.9c3.8-2.2,5.1-7,2.9-10.8l-7.5-12.9C172.1,5.8,162,0,153,0H68.9C60,0,49.9,5.8,45.4,13.6l-42,72.8
	c-4.5,7.7-4.5,19.4,0,27.2l42,72.8C49.9,194.2,60,200,68.9,200H153c8.9,0,19.1-5.8,23.5-13.6l42-72.8
	C223.1,105.8,223.1,94.2,218.6,86.4z"/>
<g>
	<polygon class="st1" points="60.9,72.5 180.6,72.5 169.7,53.7 71.8,53.7 77.2,44.2 164.3,44.2 153.4,25.4 66.3,25.4 25.5,96.1
		47.3,96.1 	"/>
	<polygon class="st1" points="47.3,105.5 25.5,105.5 66.3,176.2 153.4,176.2 164.3,157.4 77.2,157.4 	"/>
</g>
<g>
	<path class="st1" d="M272.7,60.5h-9.6v11h8.2v4.8h-8.2v16.5h-5.6V55.5h15.2V60.5z"/>
	<path class="st1" d="M306.9,92.8h-15.4V55.5h15.3v4.9H297v10.9h8.4v4.8H297v11.7h9.9V92.8z"/>
	<path class="st1" d="M341.7,92.8h-15.4V55.5h15.3v4.9h-9.7v10.9h8.4v4.8h-8.4v11.7h9.9V92.8z"/>
	<path class="st1" d="M375.7,92.8h-14.6V55.5h5.6v32.3h9.1V92.8z"/>
	<path class="st1" d="M409.2,92.8h-14.6V55.5h5.6v32.3h9.1V92.8z"/>
	<path class="st1" d="M433.8,92.8h-5.6V55.5h5.6V92.8z"/>
	<path class="st1" d="M472.8,92.8h-4.9L459,69.3c0.2,1.1,0.4,2,0.4,2.7v20.7h-5.4V55.5h4.9l8.9,23c-0.2-1.1-0.4-2-0.4-2.7V55.5h5.4
		V92.8z"/>
	<path class="st1" d="M508.3,92.8h-15.4V55.5h15.3v4.9h-9.7v10.9h8.4v4.8h-8.4v11.7h9.9V92.8z"/>
</g>
<g>
	<path class="st0" d="M308.6,159.5c-5,5.9-11.1,8.7-18.6,8.7c-6.8,0-12.3-2.1-16.7-6.5c-4.4-4.3-6.6-9.6-6.6-16.1
		c0-4.2,1-8.1,2.9-11.5c2-3.4,4.8-6.1,8.3-8.1c3.6-2,7.5-3,11.7-3c3.9,0,7.4,0.8,10.6,2.3c3.2,1.5,6,3.8,8.3,6.8l1,1.3l7-5.3
		l-0.9-1.3c-2.9-4-6.6-7.1-11-9.3c-4.4-2.2-9.5-3.3-15-3.3c-9.1,0-16.8,3-22.9,8.9c-6.1,5.9-9.2,13.3-9.2,22
		c0,8.2,2.5,15.3,7.6,21.2c6,6.9,14.3,10.4,24.6,10.4c5.4,0,10.4-1,14.8-3.1c4.4-2.1,8.2-5,11.1-8.8l1-1.3l-7-5.3L308.6,159.5z"/>
	<path class="st0" d="M388.6,153.3c-0.1-6-1.7-11.2-5-15.3c-4.6-5.8-10.7-8.7-18.3-8.7c-7.4,0-13.4,2.9-17.8,8.5
		c-3.5,4.4-5.2,9.5-5.2,15.1c0,6,2.1,11.4,6.2,16.2c4.1,4.8,9.9,7.3,17.2,7.3c3.3,0,6.2-0.5,8.8-1.5c2.6-1,5-2.5,7.1-4.4
		c2.1-1.9,3.9-4.4,5.5-7.5l0.7-1.4l-7.3-3.8l-0.8,1.3c-1.5,2.6-3,4.4-4.2,5.5c-1.3,1.1-2.8,2-4.6,2.7c-1.8,0.7-3.7,1-5.7,1
		c-4,0-7.2-1.4-10-4.2c-2.4-2.5-3.7-5.5-4.1-9.2h37.5L388.6,153.3z M352.2,147c1-2.5,2.2-4.5,3.7-5.8c2.7-2.4,5.8-3.5,9.5-3.5
		c2.2,0,4.4,0.5,6.4,1.4c2,0.9,3.7,2.2,4.9,3.7c0.9,1.1,1.6,2.5,2.2,4.3H352.2z"/>
	<path class="st0" d="M448.4,131.9c-2.7-1.8-5.8-2.6-9.2-2.6c-3.3,0-6.4,0.8-9.3,2.3c-1.7,0.9-3.3,2.1-4.8,3.6v-4.8h-8.6v45h8.6
		v-16.9c0-5.3,0.2-9,0.7-11c0.7-2.9,2.2-5.2,4.6-7.2c2.3-1.9,4.8-2.9,7.7-2.9c2.5,0,4.4,0.6,5.9,1.7c1.5,1.2,2.5,2.9,3,5.4
		c0.3,1,0.6,3.4,0.6,9.2v21.5h8.6v-23.1c0-6-0.6-10.3-1.9-13.2C453.1,136.1,451.1,133.7,448.4,131.9z"/>
	<polygon class="st0" points="499,114.9 490.5,114.9 490.5,130.4 483.1,130.4 483.1,138.2 490.5,138.2 490.5,175.3 499,175.3
		499,138.2 507.6,138.2 507.6,130.4 499,130.4 	"/>
	<path class="st0" d="M543,131.3c-0.9,0.6-1.8,1.3-2.7,2.2v-3.2h-8.7v45h8.7v-15.7c0-7.1,0.3-11.8,0.9-14c0.8-2.8,1.9-4.8,3.3-6.1
		c1.4-1.2,2.7-1.8,4.1-1.8c0.4,0,1.1,0.1,2.2,0.6l1.3,0.5l4.4-7.1l-1.5-0.8C550.7,128.4,546.7,128.9,543,131.3z"/>
	<path class="st0" d="M614.8,135.3c-1.5-1.5-3.2-2.7-5-3.6c-3-1.6-6.4-2.4-10.1-2.4c-6.4,0-11.9,2.3-16.4,6.9
		c-4.5,4.6-6.8,10.1-6.8,16.6c0,6.5,2.3,12.2,6.7,16.8c4.5,4.6,10,6.9,16.3,6.9c3.6,0,6.9-0.8,9.9-2.2c1.9-0.9,3.6-2.1,5.3-3.6v4.8
		h8.5v-45h-8.5V135.3z M610.8,142.1c2.9,3,4.3,6.6,4.3,11c0,2.9-0.6,5.5-1.9,7.8c-1.3,2.3-3.1,4.1-5.5,5.4c-4.7,2.7-10.4,2.7-14.9,0
		c-2.3-1.3-4.1-3.2-5.5-5.7c-1.4-2.4-2.1-5-2.1-7.6c0-2.7,0.7-5.2,2-7.6c1.3-2.4,3.2-4.3,5.4-5.6c2.3-1.3,4.8-2,7.5-2
		C604.5,137.7,607.9,139.1,610.8,142.1z"/>
	<rect x="652.6" y="114.3" class="st0" width="8.6" height="61.1"/>
</g>
</svg>

`,
]

export const logoMini = [
  '200 200',
  `
  <?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#CFA65F;}
	.st1{fill:#A8CF6A;}
</style>
<path class="st0" d="M197,87.8L187.3,71c-2-3.4-6.3-4.6-9.8-2.6c-3.4,2-4.6,6.3-2.6,9.8l12.6,21.8l-2.9,5.1c0,0,0,0,0,0l-18.9,32.8
	l-21.9,37.9h-5.9H62.1h-5.9l-21.9-37.9l-18.9-32.8c0,0,0,0,0,0l-2.9-5.1l43.8-75.8h5.9h75.8h5.9l7.9,13.8l1.7,3
	c2,3.4,6.3,4.6,9.8,2.6c3.4-2,4.6-6.3,2.6-9.8l-6.7-11.7c-4-7-13.1-12.2-21.2-12.2H62.1c-8.1,0-17.2,5.3-21.2,12.2L3,87.8
	c-4,7-4,17.5,0,24.5l37.9,65.6c4,7,13.1,12.2,21.2,12.2h75.8c8.1,0,17.2-5.3,21.2-12.2l37.9-65.6C201,105.3,201,94.7,197,87.8z"/>
<g>
	<polygon class="st1" points="54.9,75.2 162.8,75.2 153,58.3 64.7,58.3 69.6,49.8 148,49.8 138.2,32.8 59.8,32.8 23,96.5 42.6,96.5
			"/>
	<polygon class="st1" points="42.6,105 23,105 59.8,168.7 138.2,168.7 148,151.7 69.6,151.7 	"/>
</g>
</svg>
  `,
]
